// Service-worker registration. Production-only — in dev, Vite's HMR and the
// SW's aggressive caching fight each other and produce stale modules.
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // eslint-disable-next-line no-console
      console.warn("[community-shield-os] SW registration failed", err);
    });
  });
}
